import React, { Component } from 'react';
import { Form, Input, Button } from 'reactstrap';
import { toast } from 'react-toastify';

import firebase from '../../firebase';
import TenantAdminPage from '../hocs/TenantAdminPage';
import { texts } from '../../config';

const db = firebase.firestore();
const tenantsRef = db.collection('tenants');

export default TenantAdminPage(class TenantAdminAllergies extends Component {
  constructor() {
    super();
    this.state = {
      newAllergy: ''
    };
  }
  componentDidMount() {
    this.listenAllergies();
  }
  listenAllergies() {
    const { match: { params: { slug } } } = this.props;
    tenantsRef
      .doc(slug)
      .collection('allergies')
      .orderBy('createdAt')
      .onSnapshot((snapshot) => {
        this.setState({ allergies: snapshot.docs.map(_ => ({ ..._.data(), id: _.id })) });
      });
  }
  clear = () => {
    this.setState({ newAllergy: '' });
  }
  onSubmit = (event) => {
    event.preventDefault();
    const { tenant: { allergies = [] }, match: { params: { slug } } } = this.props;
    const { newAllergy } = this.state;
    if (!newAllergy) return;
    tenantsRef
      .doc(slug)
      .collection('allergies')
      .add({ name: newAllergy, createdAt: new Date() })
      .then(this.clear)
      .then(() => toast.success('追加しました'));
  }
  delete = (id) => {
    if (!window.confirm('本当に削除しますか？')) return;
    const { match: { params: { slug } } } = this.props;
    tenantsRef
      .doc(slug)
      .collection('allergies')
      .doc(id)
      .delete()
      .then(() => toast.success('削除しました'));
  }
  onChangeAllergy = ({ target: { value } }) => {
    this.setState({ newAllergy: value });
  }
  render() {
    const { match: { params: { slug } } } = this.props;
    const { newAllergy, allergies } = this.state;
    return (
      <div className="tenant-admin-allergies">
        <div className="d-flex justify-content-center mb-3">
          <h4>アレルギー設定</h4>
        </div>
        <Form className="d-flex justify-content-end" onSubmit={this.onSubmit}>
          <Input className="mr-2" style={{ width: '200px' }} value={newAllergy} onChange={this.onChangeAllergy} />
          <Button type="submit" color="primary" disabled={!newAllergy}>
            <span className="fas fa-plus mr-1" />
            追加
          </Button>
        </Form>
        <table className="table mt-5">
          <tbody>
            {
              (allergies || []).map(({ name, id }) => {
                return (
                  <tr key={id}>
                    <td>
                      {name}
                    </td>
                    <td>
                      <Button color="danger" onClick={this.delete.bind(this, id)}>
                        <span className="fas fa-trash mr-1" />
                        削除
                      </Button>
                    </td>
                  </tr>
                );
              })
            }
          </tbody>
        </table>
      </div>
    );
  }
});
